import React, { useEffect, useState } from 'react'
import {Card, Avatar, Button, Row, Col, Typography, Space, Rate} from 'antd'
import { LeftOutlined, RightOutlined } from '@ant-design/icons'
import type { FC } from 'react'
import { reviewsData } from './../data'

const { Text, Paragraph } = Typography

interface Review {
    author: string
    login: string
    text: string
    img: string
}

interface ReviewsProps {
    count?: number
    autoplay?: boolean
    interval?: number
}

const Reviews: FC<ReviewsProps> = ({ count = 1, autoplay = true, interval =8000 }) => {
    const [data, setData] = useState<Review[]>([])
    const [currentSlice, setCurrentSlice] = useState({ start: 0, end: count })

    const hasNextSlice = currentSlice.end < reviewsData.length
    const hasPrevSlice = currentSlice.start > 0

    const handleClickNextSlide = () => {
        const nextStart = currentSlice.start + count
        const nextEnd = currentSlice.end + count

        if (nextEnd <= reviewsData.length) {
            setData(reviewsData.slice(nextStart, nextEnd))
            setCurrentSlice({ start: nextStart, end: nextEnd })
        } else {
            // Цикл заново
            setData(reviewsData.slice(0, count))
            setCurrentSlice({ start: 0, end: count })
        }
    }

    const handleClickPrevSlide = () => {
        const prevStart = Math.max(currentSlice.start - count, 0)
        const prevEnd = Math.max(currentSlice.end - count, count)
        setData(reviewsData.slice(prevStart, prevEnd))
        setCurrentSlice({ start: prevStart, end: prevEnd })
    }

    useEffect(() => {
        setData(reviewsData.slice(0, count))
        setCurrentSlice({ start: 0, end: count })
    }, [count])

    useEffect(() => {
        if (!autoplay) return
        const timer = setInterval(() => {
            handleClickNextSlide()
        }, interval)

        return () => clearInterval(timer)
    }, [currentSlice, autoplay])

    return (
        <Row justify="center" align="middle" gutter={[24, 24]}>
            {hasPrevSlice && (
                <Col>
                    <Button shape="circle" icon={<LeftOutlined />} onClick={handleClickPrevSlide} />
                </Col>
            )}

            {data.map((review, index) => (
                <Col key={index} xs={24} sm={20} md={16} lg={12}>
                    <Card>
                        <Card.Meta
                            avatar={<Avatar src={review.img} size={64} />}
                            title={
                                <Space direction="vertical" size={0}>
                                    <Text strong>{review.author}</Text>
                                </Space>
                            }
                            description={
                                <>
                                    <Rate disabled defaultValue={5} style={{ fontSize: 16, marginBottom: 8 }} />
                                    <Paragraph>{review.text}</Paragraph>
                                </>
                            }
                        />
                    </Card>
                </Col>
            ))}

            {hasNextSlice && (
                <Col>
                    <Button shape="circle" icon={<RightOutlined />} onClick={handleClickNextSlide} />
                </Col>
            )}
        </Row>
    )
}

export default Reviews
